import React, { useState } from "react";
import "./BrokerIntegration.css";
import { brokersList } from "./config/brokers";
import SearchIcon from "./assets/images/SearchIcon";
import ArrowIcon from "./assets/images/ArrowIcon";
import StockYaariLogo from "./assets/images/StockYaariLogo";
import BrokersItem from "./components/BrokerList/BrokersItem";
import fadedStockyaariLogo from "./assets/images/fadedStockyaariLogo.png";
import { useNavigate } from "react-router-dom";
import Footer from "./components/Footer/Footer";
const BrokerIntegration = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  // Filter brokers based on search
  const filteredBrokers = brokersList.filter((broker) =>
    broker.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleBrokerClick = (broker) => {
    // Navigate with broker data in state
    navigate(`/broker-integration/${broker.name}`, { state: { broker } });
  };

  return (
    <div className="broker-integration-container">
      <div className="broker-integration-wrapper">
        {/* Search Bar */}
        <div className="search-container">
          <div className="search-input-wrapper">
            <SearchIcon />
            <input
              type="text"
              placeholder="Search broker"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
        </div>

        {/* Broker List */}
        <div className="broker-list">
          {filteredBrokers.length > 0 ? (
            filteredBrokers.map((broker) => (
              <BrokersItem
                key={broker.id}
                broker={broker}
                onClick={handleBrokerClick}
              />
            ))
          ) : (
            <div className="no-results">
              <p>No brokers found</p>
            </div>
          )}
        </div>

        {/* Footer Logo */}
        {/* <div className="footer-logo">
          <img src={fadedStockyaariLogo} alt="StockYaari Logo" />
          <p className="version-text">version 1.852</p>
        </div> */}
        <Footer />
      </div>
    </div>
  );
};

export default BrokerIntegration;
